import styled from 'styled-components'

const StyledPhotosView = styled.div`
  height: 100%;
  overflow-y: auto;
`

export default StyledPhotosView
